var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.15 8.87C10.51 9.23 10.51 9.79 10.15 10.15C9.96999 10.33 9.75 10.41 9.51 10.41C9.27 10.41 9.05001 10.33 8.87001 10.15L5.21 6.49L1.54999 10.15C1.36999 10.33 1.15 10.41 0.91 10.41C0.67 10.41 0.45001 10.33 0.27001 10.15C-0.0899902 9.79 -0.0899902 9.23 0.27001 8.87L3.93 5.21L0.27001 1.55C-0.0899902 1.19 -0.0899902 0.629997 0.27001 0.269998C0.63001 -0.0900024 1.18999 -0.0900024 1.54999 0.269998L5.21 3.92999L8.87001 0.269998C9.23001 -0.0900024 9.78999 -0.0900024 10.15 0.269998C10.51 0.629997 10.51 1.19 10.15 1.55L6.48998 5.21L10.15 8.87Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x_icon.451853d322ee9863cafbe6dedd7875b1.svg";
export { ForwardRef as ReactComponent };